import { Pipe, PipeTransform } from '@angular/core';
import { DateUtil } from '../util/date.util';

@Pipe({
    name: 'simpleDate'
})
export class SimpleDatePipe implements PipeTransform {

    transform(value: any) {
        if (value != null) {
            if (value.seconds) {
                let newDate = new Date(value.seconds * 1000);
                // return newDate.getDate() + "" + DateUtil.getMonthString("" + (newDate.getMonth() + 1)) + " " + newDate.getHours() + ":" + newDate.getMinutes();    
                return newDate.getDate() + "" + DateUtil.getMonthString("" + (newDate.getMonth() + 1)) + " " + newDate.getFullYear();
            } if (value._seconds) {
                let newDate = new Date(value._seconds * 1000);
                // return newDate.getDate() + "" + DateUtil.getMonthString("" + (newDate.getMonth() + 1)) + " " + newDate.getHours() + ":" + newDate.getMinutes();    
                return newDate.getDate() + "" + DateUtil.getMonthString("" + (newDate.getMonth() + 1)) + " " + newDate.getFullYear();
            } else {
                if (typeof value === 'string' || value instanceof String) {
                    return value;
                } else {
                    if (Number.isInteger(value)) {
                        value = new Date(value);
                    }
                    try {
                        return value.getDate() + "" + DateUtil.getMonthString("" + (value.getMonth() + 1)) + " " + value.getFullYear();
                    } catch (error) {
                        console.log(value);
                        console.log(error);
                        return "-";
                    }
                }
            }
        } else {
            return "-";
        }
    }

}
